import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css';

import AppRouter from './Routes';
import store from './store';

import mixpanel from './utils/mixpanel';  

if (process.env.NODE_ENV === "production") {
  mixpanel.init('ffef6e2ce617a23d1c2ae8722e17963a', {debug: false, track_pageview: true, persistence: 'localStorage', record_sessions_percent: 100});
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.email) {
    mixpanel.identify(user.email);
    mixpanel.people.set('$email', user.email)
  }
}

const GOOGLE_CLIENT_ID = '517815126133-54u2240mtpg7t640v3d69l668q46dun9.apps.googleusercontent.com';

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter forceRefresh={true}>
        <div className="App">
          <Provider store={store}>
            <AppRouter />
          </Provider>
        </div>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
